// extracted by mini-css-extract-plugin
module.exports = {"MessageContainer":"CustomMessage_MessageContainer__3-Qxa","content":"CustomMessage_content__PHDg0","header":"CustomMessage_header__116J1"};